// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"06e9cd9f","195":"ff558373","365":"31be8cc6","708":"0b7b3796","710":"1c1fd1a9"}[chunkId] + ".chunk.js";
};